import { parseQueryString, stringifyOptions } from "@/common/searchOptions"
import { windowObj as window } from "@/common/serverSideRendering"
import { pickBy } from "lodash/fp"
import { stringify } from "query-string"

const ARRAY_FIELD_NAMES = ["program_ids", "timetable", "special_treatments", "struggle_with"]

const getDecodedSearchString = () => {
  try {
    const decodedSearchString = decodeURIComponent(window.location.search)
    return decodedSearchString
  } catch (_) {
    return window.location.search
  }
}

export const getSearchParamsFromUrl = (paramsWithoutCast = []) => {
  const searchParams = parseQueryString(getDecodedSearchString(), paramsWithoutCast)
  ARRAY_FIELD_NAMES.forEach(param => {
    if (searchParams[param] && !Array.isArray(searchParams[param])) {
      searchParams[param] = [searchParams[param]]
    }
  })
  return searchParams
}

export const getQueryStringFromParams = params => {
  const filteredParams = pickBy(Boolean)(params)
  return `?${stringify(filteredParams, stringifyOptions)}`
}

export const searchParamsToFormValues = params => {
  return {
    ...params,
    program_ids: params.program_ids && Array.isArray(params.program_ids) ? params.program_ids : [],
  }
}

export const formValuesToSearchParams = params => {
  return {
    ...params,
    zip: params.offline && params.zip ? params.zip : null,
  }
}
